// src/utils/eventTrackern.ts

/**
 * EventTrackern: Centralized event tracking utility for analytics and other event sinks.
 * Supports GA4 and can be extended for other analytics/event services.
 */

export type EventType = 'click' | 'view' | 'submit' | 'custom';

export interface TrackEventParams {
  eventName: string; // e.g. 'BuyButton'
  eventType: EventType; // e.g. 'click'
  action: string; // e.g. 'Download'
  details?: Record<string, unknown>; // Additional event details (optional)
}

// Google Analytics 4 event tracker
function trackGA4Event({ eventName, eventType, action, details }: TrackEventParams) {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', `${eventName}::${eventType}::${action}`, details || {});
  }
}

// Main event tracker service
export function trackEvent(params: TrackEventParams) {
  // Add more sinks/services here as needed
  trackGA4Event(params);
}
